'use strict';

/* global yith_wcaf */

import { $ } from '../../src/globals.js';
import YITH_WCAF_Admin_Notes from './modules/yith-wcaf-admin-notes';
import YITH_WCAF_Admin_Panel from './modules/yith-wcaf-admin-panel';

class YITH_WCAF_Commissions extends YITH_WCAF_Admin_Panel {
	constructor() {
		const $containers = $( '#yith_wcaf_panel_commissions-list' ).add(
			'#yith_wcaf_panel_commission_details'
		);

		super( $containers );

		this.initNotes();
	}

	initNotes() {
		const $container = $( '#commission_notes' ),
			$objectID = $( '#commission_id' );

		if ( ! $container.length || ! $objectID.length ) {
			return;
		}

		new YITH_WCAF_Admin_Notes( $container, 'commission', $objectID.val() );
	}
}

$( () => new YITH_WCAF_Commissions() );
